import fetch from 'isomorphic-fetch';
import { checkStatus } from '../../util';
import { ROOT } from '../../../constants/root';

export function getInstitutions() {
	return function(dispatch, getState) {		

		const URL = `${ROOT}/institution/`;		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setInstitutionsList(json));
		})
		.catch((e) => {
			console.error(e);
		});
	};
}

function setInstitutionsList(institutions) {
	return {
		type: "SET_INSTITUTIONS_LIST",
		institutions
	};	
}


// WEBPACK FOOTER //
// ./src/state/domains/institutions/actions.js